var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContrast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4532 10.47C27.1931 9.62716 26.8491 8.81255 26.4263 8.03844C25.8011 6.88952 25.0149 5.83584 24.0916 4.90938C22.1948 3.01277 19.7782 1.7212 17.1474 1.198C14.5165 0.674805 11.7896 0.943468 9.31149 1.97002C6.83335 2.99658 4.71526 4.73492 3.22505 6.96523C1.73484 9.19554 0.939453 11.8177 0.939453 14.5C0.939453 17.1824 1.73484 19.8045 3.22505 22.0348C4.71526 24.2651 6.83335 26.0034 9.31149 27.03C11.7896 28.0565 14.5165 28.3252 17.1474 27.802C19.7782 27.2788 22.1948 25.9872 24.0916 24.0906C25.0149 23.1642 25.8011 22.1105 26.4263 20.9616C26.8491 20.1875 27.1931 19.3729 27.4532 18.53C28.2699 15.9054 28.2699 13.0946 27.4532 10.47ZM2.87597 14.5C2.87597 11.4169 4.10075 8.46 6.28086 6.27989C8.46097 4.09978 11.4178 2.87501 14.501 2.87501V26.125C11.4178 26.125 8.46097 24.9002 6.28086 22.7201C4.10075 20.54 2.87597 17.5831 2.87597 14.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.a51e0d30.svg";
export { ForwardRef as ReactComponent };